import { Component, input, output } from '@angular/core';
import { AixDataTestingDirective } from '../../directives/data-testing/data-testing.directive';

@Component({
    selector: 'aix-thumbnail',
    templateUrl: './aix-thumbnail.component.html',
    styleUrls: ['./aix-thumbnail.component.scss'],
    standalone: true,
    imports: [AixDataTestingDirective]
})
export class AixThumbnailComponent {
    thumbnail = input<string | undefined>();
    id = input<string>();
    isSelected = input(false);
    actionClick = output<string>();

    onActionClicked() {
        this.actionClick.emit(this.id() as unknown as string);
    }
}
